/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import MedicationType from 'linced-app/enums/medical/medication-type';
import { isEmpty } from '@ember/utils';

const autoinjectorAndInhalerTypes = [
  MedicationType.AUTOINJECTOR___STANDARD,
  MedicationType.AUTOINJECTOR___JUNIOR,
  MedicationType.ASTHMA_INHALER___GENERAL_USE,
];

export default class StocktakeRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      batches: this.store.findAll('medical/batch'),
      medications: this.store
        .findAll('medical/medication')
        .then((medications) => {
          return medications.filter((medication) => {
            return (
              autoinjectorAndInhalerTypes.includes(medication.get('type')) &&
              isEmpty(medication.get('person_id'))
            );
          });
        }),
    });
  }
}
